// Hand-drawn line icons for the four core services - used instead of emoji
// so the service badges render crisp and identical across every platform.

const base = {
  fill: 'none',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export function CodeIcon({ size = 28, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" stroke={color} {...base}>
      <polyline points="8.5 6 3 12 8.5 18" />
      <polyline points="15.5 6 21 12 15.5 18" />
      <line x1="14" y1="4" x2="10" y2="20" />
    </svg>
  );
}

export function GlobeIcon({ size = 28, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" stroke={color} {...base}>
      <circle cx="12" cy="12" r="9" />
      <ellipse cx="12" cy="12" rx="4" ry="9" />
      <line x1="3" y1="12" x2="21" y2="12" />
    </svg>
  );
}

export function DeviceIcon({ size = 28, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" stroke={color} {...base}>
      <rect x="7" y="2" width="10" height="20" rx="2" />
      <line x1="11" y1="18" x2="13" y2="18" />
    </svg>
  );
}

export function TrendingUpIcon({ size = 28, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" stroke={color} {...base}>
      <polyline points="3 17 9.5 10.5 13.5 14.5 21 7" />
      <polyline points="14.5 7 21 7 21 13.5" />
    </svg>
  );
}
